const ListPoint = ({ children }) => {
  return <li className="expand">{children}</li>;
};

export default ListPoint;
